
(() => {
  function initCollectionProgress() {
    document.querySelectorAll(
      ".section-collection-list slider-component"
    ).forEach((slider) => {
      const list = slider.querySelector(".collection-list");
      if (!list) return;

      let track = slider.querySelector(".collection-list-progress");

      if (!track) {
        track = document.createElement("div");
        track.className = "collection-list-progress";
        track.setAttribute("aria-hidden", "true");

        const indicator = document.createElement("div");
        indicator.className = "collection-list-progress__indicator";
        track.appendChild(indicator);
        slider.appendChild(track);
      }

      const indicator = track.querySelector(
        ".collection-list-progress__indicator"
      );

      function updateProgress() {
        const maxScroll = list.scrollWidth - list.clientWidth;
        const trackWidth = track.getBoundingClientRect().width;
        const indicatorWidth = Math.max(30, trackWidth * 0.15);
        const travel = Math.max(0, trackWidth - indicatorWidth);
        const progress = maxScroll > 0
          ? Math.min(1, Math.max(0, list.scrollLeft / maxScroll))
          : 0;

        indicator.style.width = `${indicatorWidth}px`;
        indicator.style.height = "3px";
        indicator.style.backgroundColor = "#ffffff";
        indicator.style.transform = `translateX(${travel * progress}px)`;

        track.style.display = maxScroll > 1 ? "block" : "none";

        console.log("Collection progress:", {
          maxScroll,
          scrollLeft: list.scrollLeft,
          trackWidth,
          indicatorWidth
        });
      }

      if (list.dataset.progressBound !== "true") {
        list.addEventListener("scroll", updateProgress, {
          passive: true
        });
        list.dataset.progressBound = "true";
      }

      updateProgress();
      requestAnimationFrame(updateProgress);
      window.addEventListener("resize", updateProgress);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCollectionProgress);
  } else {
    initCollectionProgress();
  }

  document.addEventListener("shopify:section:load", initCollectionProgress);
})();
